import Keycloak from 'keycloak-js';

const KeyCloakService = {
    install(Vue, options) {
        let authenticated = false;

        const keycloak = Keycloak(options.keycloakOptions);

        function updateAuthentication(isAuthenticated) {
            if (isAuthenticated) {
                authenticated = true;
                localStorage.setItem('accessToken', keycloak.token);
            }
        }

        function updateTokenperiodically() {
            setInterval(() => {
                keycloak
                    .updateToken(options.tokenOptions.minValidity / 1000)
                    .success(function (refreshed) {
                        updateAuthentication(refreshed);
                    })
                    .error(function () {
                        location.reload();
                    });
            }, options.tokenOptions.validity -
                options.tokenOptions.minValidity);
        }

        Vue.prototype.$keycloak = {
            isAuthenticated: function () {
                return authenticated;
            },
            init: function () {
                return new Promise((resolve) => {
                    keycloak
                        .init(options.keycloakInitOptions)
                        .success((isAuthenticated) => {
                            updateAuthentication(isAuthenticated);
                            if (isAuthenticated) {
                                updateTokenperiodically();
                            }
                            resolve(isAuthenticated);
                        });
                });
            },
            getUserInfo: function () {
                return new Promise((resolve) => {
                    keycloak.loadUserInfo().success((user) => {
                        resolve(user);
                    });
                });
            },
            hasUserRole: function (role) {
                const roles = keycloak.tokenParsed.realm_access.roles;
                return roles.includes(role);
            }
        };
    }
};

export default KeyCloakService;
